export default __webpack_public_path__ + "static/roche_logo-87278f9287e25a74d597b76bdeb39c86.svg";